import IconBase from "./IconBase";

const CopyIcon = props => (
  <IconBase {...props}>
    <g
      transform="translate(3 3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <rect y="4" width="10" height="10" rx="2" />
      <path d="M6 0h4a4 4 0 0 1 4 4v4" />
    </g>
  </IconBase>
);

export default CopyIcon;
